import React, { useMemo, useRef } from "react";

import { WorkloadTableRowData } from "@src/types/role_request_types";
import {
  getColumnDefs,
  getGridOptions,
} from "@src/utils/workload_table_grid_options";
import { getWorkloadDates } from "@src/utils/workload_table_utils";
import { ColDef, GridApi, GridReadyEvent } from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import "./workload_table.less";

interface WorkloadTableProps {
  requestRowData: WorkloadTableRowData[];
}

const WorkloadTable: React.FC<WorkloadTableProps> = ({ requestRowData }) => {
  const gridApi = useRef<GridApi>(null);

  const columnDefs = useMemo<ColDef[]>(() => {
    const { startDate, endDate } = getWorkloadDates(requestRowData);
    return getColumnDefs(startDate, endDate);
  }, [requestRowData]);

  /**
   * AG Grid Ready event
   *
   * @param {GridReadyEvent} event - AG Grid event parameter
   */
  function onGridReady(event: GridReadyEvent): void {
    gridApi.current = event.api;
  }

  return !requestRowData?.length ? (
    <div className="workload-table__no-allocation">
      No allocation added to this request yet
    </div>
  ) : (
    <AgGridReact
      rowData={requestRowData}
      gridOptions={getGridOptions()}
      onGridReady={onGridReady}
      columnDefs={columnDefs}
    />
  );
};

export default WorkloadTable;
